import React, { useState, cloneElement } from 'react';
import { Box, MobileStepper, Button } from '@mui/material';
import { DefaultModal } from 'components/Modals/DefaultModal';
import { ChangesModalContent } from 'components/UserProfile/components/ChangesModal';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { useStyles } from 'components/TeamOverview/components/NotificationsModal/styles';

export const notificationModals = [<ChangesModalContent key="changesModal" />];

export const LAST_NOTIFICATION_UPDATE_DATE = 1750769581473;

export const NotificationsModal = (props) => {
  const { open, onClose, forceOpen } = props;
  const [activeStep, setActiveStep] = useState(0);
  const { classes } = useStyles();

  const handleNext = () => {
    setActiveStep((prevActiveStep) =>
      prevActiveStep === notificationModals.length - 1 ? 0 : prevActiveStep + 1,
    );
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) =>
      !prevActiveStep ? notificationModals.length - 1 : prevActiveStep - 1,
    );
  };

  const notificationsContent = notificationModals.map((Content) =>
    cloneElement(Content, { key: Content.key, ...props }),
  );

  return (
    <DefaultModal
      open={open || forceOpen}
      isLimitedHeight
      styles={{ padding: 0, maxHeight: '80vh' }}
      onClose={onClose}
    >
      <Box className={classes.container}>
        <Box className={classes.content}>
          {notificationsContent[activeStep]}
        </Box>
        <MobileStepper
          variant="dots"
          steps={notificationModals.length}
          position="static"
          activeStep={activeStep}
          className={classes.stepper}
          nextButton={
            <Button
              size="small"
              onClick={handleNext}
              disabled={notificationModals.length - 1 === activeStep}
            >
              <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              <KeyboardArrowLeft />
            </Button>
          }
        />
      </Box>
    </DefaultModal>
  );
};
